import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Page } from '../../../models/paging/page';
import { PagedData } from '../../../models/paging/paged-data';
import { CategoryService } from '../../../services/category.service';
import { Category } from '../../../models/category';
import { saveAs as importedSaveAs } from 'file-saver';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnInit {
  filter: any = {
    name: ''
  };
  page = new Page();
  rows = Array<Category>();

  //columns = [
  //  { name: 'Name', prop: 'name' },
  //  { name: 'Inspection Interval', prop: 'inspection_Interval' },
  //  { name: 'Time Per Unit', prop: 'time_Per_Unit' },
  //  { name: 'Hours', prop: 'hours' },
  //  { name: 'Parent Category', prop: 'parent_Category_Name' },
  //  { name: 'Option', prop: '' },
  //]
  init: boolean;

  constructor(public categoryService: CategoryService, public router: Router) {
    this.page.pageNumber = 0;
    this.page.size = 10;
  }

  ngOnInit() {
    this.setPage({ offset: 0 });
    this.init = true;
  }

  edit(row) {
    this.router.navigate(['administration/categories/manage'], { queryParams: { id: row.id } });
  }


  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.categoryService.getResults(this.page, this.filter.name).then((pagedData) => {
      this.page = pagedData.page;
      this.rows = pagedData.data;
      if (this.init) {
        this.gotoTop();
        this.init = false;
      }
    });
  }

  generateExcel() {
    this.categoryService.getExcel(this.page, this.filter.name).then((data) => {
      importedSaveAs(data, 'Report.xlsx');
    });
  }
  gotoTop() {
    console.log("GOTO TOP");
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    console.log(top);
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }
}
